export const CATEGORIES = [
  { slug: "a-la-une", name: "À la une", color: "#E11D48", featuredPage: true, subs: [] },
  { slug: "politique", name: "Politique", color: "#1D4ED8", subs: ["Politique nationale", "Politique internationale", "Élections et institutions"] },
  { slug: "entre-nous", name: "Entre Nous", color: "#B45309", subs: [] },
  { slug: "economie", name: "Économie", color: "#047857", subs: ["Entreprises", "Finance", "Emploi", "Commerce"] },
  { slug: "societe", name: "Société", color: "#7C3AED", subs: ["Éducation", "Santé", "Environnement", "Faits de société"] },
  { slug: "culture", name: "Culture", color: "#DB2777", subs: ["Musique", "Cinéma", "Arts", "Festivals", "Littérature"] },
  { slug: "sport", name: "Sport", color: "#EA580C", subs: ["Football", "Basketball", "Autres sports"] },
  { slug: "international", name: "International", color: "#0284C7", subs: ["Europe", "Afrique", "Amériques", "Asie", "Moyen-Orient"] },
  { slug: "actualites", name: "Actualités", color: "#475569", subs: ["Dernières nouvelles", "Flash info"] },
  { slug: "annonce-publicitaire", name: "Annonce publicitaire", color: "#9333EA", subs: ["Immobilier", "Automobile", "Services", "Divers"] },
  { slug: "emplois", name: "Emplois", color: "#0D9488", subs: ["Offres d'emploi", "Stages", "Concours", "Formations"] },
  { slug: "sante-360", name: "Santé 360", color: "#0EA5E9", subs: ["Bien-être", "Médecine", "Nutrition", "Prévention"] },
];

// Categories usable when writing an article (excludes the virtual "À la une" page)
export const EDITABLE_CATEGORIES = CATEGORIES.filter((c) => !c.featuredPage);

const BY_SLUG = Object.fromEntries(CATEGORIES.map((c) => [c.slug, c]));

export const getCategory = (slug) => BY_SLUG[slug] || { slug, name: slug, color: "#475569", subs: [] };
